import { useSearchParams } from "react-router-dom";
import { BSAQueryParams } from "../types/BsaQueryParamType";

export const useQueryParams = () => {
  const [searchParams] = useSearchParams();

  const getQueryParams = (): BSAQueryParams => {
    return {
      LandscapeID: searchParams.get("LandscapeID") || "",
      LandscapeName: searchParams.get("LandscapeName") || "",
      MarketValue: searchParams.get("Mkt") || "",
      MCO: searchParams.get("MCO") || "",
      CompanyCodes: searchParams.get("CompanyCodes") || "",
      Country: searchParams.get("Country") || "",
      RptYear: searchParams.get("RptYear") || "",
      RptMonthNo: searchParams.get("RptMonthNo") || "",
      CompYear: searchParams.get("CompYear") || "",
      CompMonthNo: searchParams.get("CompMonthNo") || "",
      ReviewScenario: searchParams.get("ReviewScenario") || "",
      CBTType: searchParams.get("CBTType") || "",
    };
  };

  const createQueryString = (params: Partial<BSAQueryParams>): string => {
    return Object.entries(params)
      .filter(
        ([_, value]) => value !== null && value !== undefined && value !== ""
      )
      .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
      .join("&");
  };

  return { getQueryParams, createQueryString };
};
